import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow.icon",
  "use": "arrow.icon-usage",
  "viewBox": "-12497.218 -16200 37.448 39.494",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-12497.218 -16200 37.448 39.494\" id=\"arrow.icon\"><path data-name=\"Union 1\" d=\"M12.1,39.494V18.724H0L18.724,0,37.447,18.723H25.8v20.77Z\" transform=\"translate(-12497.218 -16200)\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow.icon.svg
// module id = Wp4G
// module chunks = 13